import * as THREE from 'three';
import { useCallback, useMemo, useRef, memo } from 'react';

import { ViewerLayer } from '../ViewerLayer';

const NUM_WIDTH_SEGMENTS = 32;
const NUM_HEIGHT_SEGMENTS = 16;
const SPHERE_RADIUS = 0.2;
export const TRIANGLES_PER_MESH = 2 * NUM_WIDTH_SEGMENTS * NUM_HEIGHT_SEGMENTS;

export interface BenchmarkMeshProps {
  key: string;
  position: Parameters<THREE.Vector3['set']>;
  rotation: Parameters<THREE.Vector3['set']>;
  isVisible?: boolean;
}

export const BenchmarkMesh = memo(({ position, rotation, isVisible }: BenchmarkMeshProps) => {
  const mesh = useRef<THREE.Mesh>();

  const meshCallback = useCallback(
    (node: THREE.Mesh | null) => {
      if (node != null) {
        const { layers } = node;

        if (isVisible ?? true) {
          layers.enable(ViewerLayer.AutoPickable);
          layers.enable(ViewerLayer.Default);
          layers.enable(ViewerLayer.SphericalViewerLayer);
        } else {
          layers.disable(ViewerLayer.AutoPickable);
          layers.disable(ViewerLayer.Default);
          layers.disable(ViewerLayer.SphericalViewerLayer);
        }

        mesh.current = node;
      }
    },
    [isVisible]
  );

  const sphereGeometryArgumentsMemo = useMemo<[number, number, number]>(
    () => [SPHERE_RADIUS, NUM_WIDTH_SEGMENTS, NUM_HEIGHT_SEGMENTS],
    []
  );
  return (
    <group position={position} rotation={rotation}>
      <mesh ref={meshCallback} position={[0, 0, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <sphereGeometry attach="geometry" args={sphereGeometryArgumentsMemo} />

        <meshPhongMaterial
          attach="material"
          color={0x22ff44}
          transparent
          opacity={0.5}
          emissive={0x22ff44}
          emissiveIntensity={0.1}
        />
      </mesh>
    </group>
  );
});
BenchmarkMesh.displayName = 'BenchmarkMesh';
